<div class="container mx-auto px-4 py-8 max-w-5xl">
  
  <div class="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h2 class="text-2xl font-bold text-gray-900">Topic Analysis</h2>
      <p *ngIf="collectionId" class="mt-1 text-sm font-semibold text-indigo-700">Colección: {{ collectionId }}</p>
      <div *ngIf="collectionsFilter && !collectionId" class="mt-1 flex items-center gap-2">
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          Analizando subconjunto filtrado: {{ getFilteredCollectionsCount() }} colecciones
        </span>
      </div>
      <p *ngIf="!collectionId && !collectionsFilter" class="mt-1 text-xs text-gray-500 font-medium">Analizando todas las colecciones de la base de datos</p>
      <p class="mt-1 text-sm text-gray-500">Frequency distribution of keywords extracted from documents.</p>
    </div>
    <div class="mt-4 sm:mt-0 bg-indigo-50 px-4 py-2 rounded-lg border border-indigo-100">
      <span class="text-xs font-semibold text-indigo-500 uppercase tracking-wider">Total Unique Topics</span>
      <div class="text-2xl font-bold text-indigo-700" *ngIf="!isLoading">{{ topics.length }}</div>
      <div class="text-2xl font-bold text-indigo-700 animate-pulse" *ngIf="isLoading">...</div>
    </div>
  </div>

  <div class="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 p-4 bg-white shadow-sm rounded-lg border border-gray-200">
    <div class="flex flex-col sm:flex-row sm:items-center gap-4">
      <div class="flex flex-col">
        <label for="startDate" class="text-sm font-medium text-gray-700 mb-1">Fecha Inicio</label>
        <input 
          type="date" 
          id="startDate" 
          [(ngModel)]="startDate" 
          (change)="fetchTopics()"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-3 py-2 border">
      </div>      
      <div class="flex flex-col">
        <label for="endDate" class="text-sm font-medium text-gray-700 mb-1">Fecha Fin</label>
        <input 
          type="date" 
          id="endDate" 
          [(ngModel)]="endDate" 
          (change)="fetchTopics()"
          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-3 py-2 border">
      </div>
    </div>
    <button 
        (click)="downloadCSV()" 
        [disabled]="isLoading || topics.length === 0"
        class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
        <svg class="mr-2 -ml-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
        </svg>
        Exportar CSV
    </button>
        
  </div>

  <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-20 bg-white rounded-lg shadow-sm border border-gray-100">
    <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600 mb-4"></div>
    <p class="text-gray-500 text-sm">Analyzing metadata...</p>
  </div>

  <div *ngIf="error" class="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-r">
    <div class="flex">
      <div class="flex-shrink-0">
        <span class="text-red-500 font-bold">!</span>
      </div>
      <div class="ml-3">
        <p class="text-sm text-red-700">{{ error }}</p>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && !error" class="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
    
    <div class="grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50 border-b border-gray-200 text-xs font-medium text-gray-500 uppercase tracking-wider">
      <div class="col-span-1 text-center">#</div>
      <div class="col-span-4 md:col-span-3">Keyword</div>
      <div class="col-span-7 md:col-span-8">Frequency</div>
    </div>

    <ul class="divide-y divide-gray-200">
      <li *ngFor="let item of topics; let i = index" class="hover:bg-gray-50 transition-colors duration-150">
        <div class="grid grid-cols-12 gap-4 px-6 py-4 items-center">
          
          <div class="col-span-1 text-center text-sm text-gray-400 font-mono">
            {{ i + 1 }}
          </div>

          <div class="col-span-4 md:col-span-3">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800 capitalize">
              {{ item.topic }}
            </span>
          </div>

          <div class="col-span-7 md:col-span-8">
            <div class="flex items-center">
              <span class="text-sm font-bold text-gray-700 w-8 text-right mr-3">{{ item.count }}</span>
              <div class="flex-1 w-full bg-gray-100 rounded-full h-3 overflow-hidden">
                <div 
                  class="h-full rounded-full transition-all duration-1000 ease-out bg-indigo-600"
                  [style.width]="getBarWidth(item.count)">
                </div>
              </div>
            </div>
          </div>

        </div>
      </li>
    </ul>

    <div *ngIf="topics.length === 0" class="text-center py-12">
      <p class="text-gray-500">No topics found in the database.</p>
    </div>

  </div>
</div>